import { render, staticRenderFns } from "./GameRegister.vue?vue&type=template&id=4ff8b34f&scoped=true"
import script from "./GameRegister.vue?vue&type=script&lang=js"
export * from "./GameRegister.vue?vue&type=script&lang=js"
import style0 from "./GameRegister.vue?vue&type=style&index=0&id=4ff8b34f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ff8b34f",
  null
  
)

export default component.exports